import { useEffect, useMemo, useState } from 'react';
import {
  getChatMessageCardPresetStorageValue,
  getChatThreadBackgroundCss,
  messageCardPresetUsesDarkText,
} from '../utils/chatThreadBackgrounds';

/**
 * Локальный пресет фона карточки сообщения + флаг контраста текста.
 */
export function useChatMessageCardAppearance() {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const bump = () => setTick((t) => t + 1);
    window.addEventListener('chat-message-card-preset-changed', bump);
    window.addEventListener('storage', bump);
    return () => {
      window.removeEventListener('chat-message-card-preset-changed', bump);
      window.removeEventListener('storage', bump);
    };
  }, []);

  return useMemo(() => {
    void tick;
    const id = getChatMessageCardPresetStorageValue();
    const css = id ? getChatThreadBackgroundCss(id) : '';
    if (!id || !css) {
      return {
        active: false,
        gradientCss: '',
        useDarkText: false,
      };
    }
    return {
      active: true,
      presetId: id,
      gradientCss: css,
      useDarkText: messageCardPresetUsesDarkText(id),
    };
  }, [tick]);
}
